import { ReviewChatRooms } from "../Model/companyReviewsObjects";

export const REVIEW_CHAT_ROOMS = 'REVIEW_CHAT_ROOMS';

const initialState = new ReviewChatRooms({}, [], []);

const reducer = (state = initialState, action) => {
    switch (action.type) {
        case REVIEW_CHAT_ROOMS:
            return action.payload;
        default:
            return state;
    }
};

const storeName = "reviewChatRooms";
const storeMapping = { [storeName]: reducer };

export const reviewChatRoomsSelector = (state) => state[storeName];

export default storeMapping; 
